import { getFirstErrorMessage } from '~/lib/axios'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'

const EventBus = window.VueEventBus

export default {
  data: () => ({
    playcards: [],

    playcard: {
      number: null,
      cvv: null,
    },

    arePlaycardsLoaded: false,

    isPrimaring: {},
    isArchiving: {},
    isAdding: false,

    primaringErrorMessage: null,
    archivingErrorMessage: null,
    addingErrorMessage: null,
  }),

  validations: {
    playcard: {
      number: {
        required,
      },
      cvv: {
        required,
      },
    },
  },

  methods: {
    emit(eventName, ...payload) {
      this.$emit(eventName, ...payload)
      EventBus.$emit(eventName, ...payload)
    },
    emitError(eventName, e, ...payload) {
      const error = getFirstErrorMessage(e)
      this.emit(eventName, error, e, ...payload)
      return error
    },

    async load() {
      const where = { is_archived: false }
      const order = 'is_primary:desc,user_order'

      try {
        const { data: { data: playcards } } = await axios.get(`${this.config.apiUri}/customer/playcard?where=${JSON.stringify(where)}&order=${order}&page_size=999`)

        this.playcards = playcards
        this.arePlaycardsLoaded = true
        this.emit('playcards.loaded', playcards)
      } catch (e) {
        this.emitError('playcards.load.error', e)
      }
    },

    async primary(playcard) {
      try {
        this.$set(this.isPrimaring, playcard.id, true)
        await axios.post(`${this.config.apiUri}/customer/playcard/${playcard.id}/primary`)
        await this.load()
        this.emit('playcard.primared', playcard)
      } catch (e) {
        this.emitError('playcard.primary.error', e, playcard)
        this.primaringErrorMessage = getFirstErrorMessage(e)
      } finally {
        this.$set(this.isPrimaring, playcard.id, false)
      }
    },

    async archive(playcard) {
      try {
        this.$set(this.isArchiving, playcard.id, true)
        await axios.post(`${this.config.apiUri}/customer/playcard/${playcard.id}/archive`)
        this.archivingErrorMessage = null
        await this.load()
        this.emit('playcard.archived', playcard)
      } catch (e) {
        this.emitError('playcard.archive.error', e, playcard)
        this.archivingErrorMessage = getFirstErrorMessage(e)
      } finally {
        this.$set(this.isArchiving, playcard.id, false)
      }
    },

    async add() {
      const payload = {
        number: this.playcard.number,
        cvv: this.playcard.cvv,
      }
      try {
        this.isAdding = true
        const { data: { data: playcard } }  = await axios.post(`${this.config.apiUri}/customer/playcard/add`, payload)
        this.addingErrorMessage = null
        await this.load()
        this.emit('playcard.added', playcard)
      } catch (e) {
        this.emitError('playcard.add.error', e, payload)
        this.addingErrorMessage = getFirstErrorMessage(e)
      } finally {
        this.isAdding = false
      }
    },
  },
}

